export default __webpack_public_path__ + "static/media/LockupM.9b6a4163.svg";